<template>
    <v-dialog ref="dialog" v-model="modal" width="290px" @click:outside="save">
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="formattedDates"
                :label="$t(`filters.labels.${name}`)"
                readonly
                v-bind="attrs"
                v-on="on"
                v-on:append="on"
                clearable
                append-icon="mdi-calendar"
                @click:append="modal = true"
                @click:clear="save"
                v-bind:class="model && model.length > 1 ? 'small-text' : ''"
            >
            </v-text-field>
        </template>
        <v-date-picker v-model="model" range scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="save">
                OK
            </v-btn>
        </v-date-picker>
    </v-dialog>
</template>

<script>
export default {
    props: ['name', 'resource'],

    data: () => ({
        model: [],
        modal: false,
    }),

    computed: {
        formattedDates: {
            get() {
                if (!this.model || this.model.length == 0) return null

                let startDate = this.model[0].split('-')
                let formattedDates = `${startDate[2]}/${startDate[1]}/${startDate[0]}`

                if (this.model.length > 1) {
                    let endDate = this.model[1].split('-')
                    formattedDates += ` - ${endDate[2]}/${endDate[1]}/${endDate[0]}`
                }

                return formattedDates
            },
            set(value) {
                this.model = value
                this.save()
            },
        },
    },

    methods: {
        save() {
            this.$store.commit('filters/apply', {
                resource: this.resource,
                filter: { name: this.name, value: this.model },
            })
            this.modal = false
        },
    },
}
</script>

<style scoped>
.small-text {
    font-size: 13px !important;
}
</style>
